import Vuex from "vuex";

function registerStoreModule(store, module) {
  const path = module.path;
  if (!path || store.hasModule(path)) return;
  const _module = Object.assign({}, module);
  delete _module.path;
  store.registerModule(path, _module);
}

const StoreService = {
  install(vue) {
    vue.use(Vuex);
    this.store = new Vuex.Store({});
    const storeContexts = require.context("@/store", true, /index\.js$/);
    storeContexts.keys().forEach((name) => {
      registerStoreModule(this.store, storeContexts(name).default);
    });
  },
  store: null
};

export default StoreService;
